/**
 * Make sidebar sticky
 */
import PerfUtils from '../perf-utils';

const classNames = {
  breadcrumb: 'breadcrumbs',
  stickyTop: 'js-sticky-top',
  stickyBottom: 'js-sticky-bottom',
};
const breadcrumbHeightProperty = '--breadcrumb-height';

export default {
  init(selector) {
    const sidebars = document.querySelectorAll(selector);

    if (sidebars.length != 1) {
      return; // no sidebar or multiple sidebars.
    }

    const sidebar = sidebars[0];
    const parent = sidebar.parentElement;
    const breadcrumb = parent.querySelector('.' + classNames.breadcrumb);

    // Rerun implementation when menu or window resizes
    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(() => {
        implementFunc(sidebar, breadcrumb);
      });

      resizeObserver.observe(sidebar);
      resizeObserver.observe(parent);
    }

    window.addEventListener(
      'resize',
      PerfUtils.debounce(() => {
        implementFunc(sidebar, breadcrumb);
      }, 100),
    );

    implementFunc(sidebar, breadcrumb);
  },
};

/**
 * Set the appropriate classes for the window size
 * @param {HTMLElement} sidebar
 * @param {HTMLElement} breadcrumb
 */
function implementFunc(sidebar, breadcrumb) {
  const sidebarHeight = sidebar.getBoundingClientRect().height;

  const de = document.documentElement;
  const windowHeight = de.getBoundingClientRect().height;

  let breadcrumbHeight = '0';

  if (breadcrumb) {
    const style = getComputedStyle(breadcrumb);

    breadcrumbHeight =
      parseFloat(style.height) + parseFloat(style.marginBottom);
  }

  de.style.setProperty(breadcrumbHeightProperty, breadcrumbHeight + 'px');

  if (sidebarHeight < windowHeight) {
    sidebar.classList.remove(classNames.stickyBottom);
    sidebar.classList.add(classNames.stickyTop);
  } else {
    sidebar.classList.remove(classNames.stickyTop);
    sidebar.classList.add(classNames.stickyBottom);
  }
}
